import { render, staticRenderFns } from "./LogisticsDetails.vue?vue&type=template&id=47be13f2&scoped=true"
import script from "./LogisticsDetails.vue?vue&type=script&lang=js"
export * from "./LogisticsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be13f2",
  null
  
)

export default component.exports